module.exports = __webpack_public_path__ + "static/media/MonkeyKing_EN.aa50ea64.png";